import { Step } from "@mui/material";
import { CMWizardModalStep } from "./wizard-modal-step.styles";

const WizardModalStep = ({ title, children, style, titleStyle, handleClose, visible, isContract }) => {

  return (
    <CMWizardModalStep style={style} isContract={isContract}>
      <Step>
        <div className="wizardStep-header">
          <h2 className="wizardStep-title" style={titleStyle}>
            {title}
          </h2>
          {visible && (
            <button className="wizardStep-closeButton" onClick={handleClose}>
              &#10006; 
            </button>
          )}
        </div>
        {children}
      </Step>
    </CMWizardModalStep>
  );
};

export default WizardModalStep;
